import resume from '../assets/pdf/resume.pdf'
import pfpImg from '../assets/pfp/img_val_2.JPG'
import pfp2Img from '../assets/pfp/cv_img_vale.JPG'


export const headerData = {
    name: 'Valeria Gonzalez',
    title: "BSc in Computer Science",
    desciption:"Passionate developer with a deep interest in understanding how everything works and learning new things every day. Currently, I am expanding my knowledge in Software Engineering, especially in Quality Assurance. I have a strong psychology background that has helped me develop better team management skills and interaction with clients. ",
    image: pfpImg,
    resumePdf: resume
}
